import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';

import { content } from './data';

import SamsungDaBasket from 'assets/images/general/samsung-da-basket.svg';
import close from 'assets/images/general/close.svg';

import './AutomaticOwnershipModal.scss';

export default function AutomaticOwnershipModal({
    isOpen,
    onToggle
}) {
    return (
        <Modal isOpen={isOpen} centered={true} toggle={onToggle}
            backdrop={true} className='AutomaticOwnershipModal'>
            <div className='AutomaticOwnershipModal__container'>
                <div className='w-100 AutomaticOwnershipModal__container__header'>
                    <img className='ic-close' src={close} onClick={onToggle}
                        alt='Close' />
                    <div className='heading-container'>
                        <img className='ic-logo' src={SamsungDaBasket} alt='free-delivery'/>
                        <span className='heading'>Automatic Ownership</span>
                    </div>
                    <div className='heading-container mt-3'>
                        <span className='subheading'>Own your device at the end of term.</span>
                    </div>
                </div>
                <div className='AutomaticOwnershipModal__container__content'>
                    {content.map((item) => (
                        <div key={item.id} id={item.id}
                            dangerouslySetInnerHTML={{ __html: item.text }} />
                    ))}
                </div>
                <div className='container d-flex align-items-center w-100 justify-content-center AutomaticOwnershipModal__container__footer'>
                    <button onClick={onToggle} className='AutomaticOwnershipModal__container__button'>Okay</button>
                </div>
            </div>
        </Modal>
    );
}

AutomaticOwnershipModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func
};
